document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initComparador();
  initParallax();
});

// Parallax suave en imágenes de banner. Solo transform (va por GPU),
// desactivado en móvil y si el usuario pide menos movimiento.
function initParallax() {
  var capas = document.querySelectorAll('[data-qv-parallax]');
  if (!capas.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 990) return;

  var visibles = [];
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      var i = visibles.indexOf(el);
      if (entry.isIntersecting && i === -1) visibles.push(el);
      if (!entry.isIntersecting && i > -1) visibles.splice(i, 1);
    });
  }, { rootMargin: '100px 0px' });
  capas.forEach(function (el) { observer.observe(el); });

  var pendiente = false;
  function pintar() {
    pendiente = false;
    var vh = window.innerHeight;
    visibles.forEach(function (el) {
      var intensidad = Number(el.getAttribute('data-qv-parallax-intensidad') || 20);
      if (!intensidad) return;
      var rect = el.getBoundingClientRect();
      // -1 (bajo la pantalla) .. 1 (sobre la pantalla)
      var progreso = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
      progreso = Math.max(-1, Math.min(1, progreso));
      var img = el.querySelector('img');
      if (img) img.style.transform = 'translate3d(0,' + (progreso * intensidad).toFixed(2) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(pintar);
  }, { passive: true });
  pintar();
}

function initReveal() {
  var els = document.querySelectorAll('.qv-reveal, .qv-reveal-scale, .qv-img-in');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('qv-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-qv-delay') || 0;
        setTimeout(function () { entry.target.classList.add('qv-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-qv-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-qv-contador'));
      var suffix = el.getAttribute('data-qv-sufijo') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initComparador() {
  var wraps = document.querySelectorAll('[data-qv-comparador]');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('[data-qv-comparador-handle]');
    var after = wrap.querySelector('[data-qv-comparador-after]');
    if (!handle || !after) return;
    var dragging = false;
    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1) * 100;
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    handle.addEventListener('pointerdown', function () { dragging = true; });
    window.addEventListener('pointerup', function () { dragging = false; });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    wrap.addEventListener('click', function (e) { setPos(e.clientX); });
  });
}
